var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbsUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9668 22.7363H4.9668C4.43636 22.7363 3.92766 22.5256 3.55258 22.1505C3.17751 21.7755 2.9668 21.2668 2.9668 20.7363V13.7363C2.9668 13.2059 3.17751 12.6972 3.55258 12.3221C3.92766 11.947 4.43636 11.7363 4.9668 11.7363H7.9668M14.9668 9.73633V5.73633C14.9668 4.94068 14.6507 4.17762 14.0881 3.61501C13.5255 3.0524 12.7624 2.73633 11.9668 2.73633L7.9668 11.7363V22.7363H19.2468C19.7291 22.7418 20.1972 22.5727 20.5647 22.2603C20.9322 21.9479 21.1745 21.5132 21.2468 21.0363L22.6268 12.0363C22.6703 11.7497 22.651 11.457 22.5701 11.1786C22.4893 10.9001 22.3489 10.6426 22.1587 10.4238C21.9684 10.2051 21.7329 10.0303 21.4684 9.91155C21.2039 9.79283 20.9167 9.73305 20.6268 9.73633H14.9668Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/thumbs-up.da2c4098.svg";
export { ForwardRef as ReactComponent };